import styled from '@emotion/native'
import webStyled from '@emotion/styled'
import { Text as BaseText, View, TouchableOpacity } from 'react-native'
import { ResourceImage } from '@ui/components'

// PALETA CORPORATIVA AENA
export const colors = {
  azulCorporativo: '#1a2732',
  azulClaro: '#C7D3E1',
  grisClaro: '#F5F5F5',
  grisMedio: '#CCCCCC',
  grisOscuro: '#707070',
  negro: '#000000',
  blanco: '#FFFFFF',
  verdeActivo: '#57a75f',
  aenaVerde: '#96ce00',
  rojoInactivo: '#c30000',
}

export const Banner = webStyled.img(({ theme }) => ({
  width: '100%',
  height: 200,
  marginBottom: theme.sizes.xs,
}))
// TIPOGRAFÍA CORPORATIVA
export const Headline1 = styled(BaseText)`
  font-family: 'SourceSans3-Light';
  font-size: 22px;
  color: ${colors.azulCorporativo};
`
export const Headline2 = styled(BaseText)`
  font-family: 'SourceSans3-SemiBold';
  font-size: 20px;
  color: ${colors.azulCorporativo};
`
export const Headline3 = styled(BaseText)`
  font-family: 'SourceSans3-Light';
  font-size: 18px;
  color: ${colors.azulCorporativo};
`
export const Headline4 = styled(BaseText)`
  font-family: 'SourceSans3-SemiBold';
  font-size: 16px;
  color: ${colors.azulCorporativo};
`
export const Headline5 = styled(BaseText)`
  font-family: 'SourceSans3-SemiBold';
  font-size: 14px;
  color: ${colors.azulCorporativo};
`
export const Headline6 = styled(BaseText)`
  font-family: 'SourceSans3-SemiBold';
  font-size: 12px;
  color: ${colors.azulCorporativo};
`
export const BodyText = styled(BaseText)`
  font-family: 'SourceSans3-Regular';
  font-size: 14px;
  color: ${colors.negro};
  white-space: normal;
  padding-left: 5px;
`
export const ErrorText = styled(BaseText)`
  font-family: 'SourceSans3-Regular';
  font-size: 12px;
  color: #ff4b4b;
`

export const MainContainer = styled.View(({ theme }) => ({
  gap: theme.sizes.md,
  paddingVertical: theme.sizes.md,
  flexDirection: 'column',
  flex: 1,
}))

// COMPONENTES DE ESTILO EXISTENTES
export const InputWrapper = styled(View)(({ theme }) => ({
}))

export const InputContainer = styled(View)(({ theme }) => ({
  paddingVertical: theme.sizes.sm,
  gap: theme.sizes.xs,
}))

export const ModalWrapper = webStyled.div(({ theme }) => ({
  width: '100%',
  height: '100vh',
  display: 'flex',
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  justifyContent: 'center',
  alignItems: 'center',
}))

export const ColumnContainer = styled.View(({ theme }) => ({
  flexDirection: 'column',
  padding: theme.sizes.sm,
  paddingTop: theme.sizes.xxs,
  justifyContent:'space-between',
  flex: 1,
  gap: theme.sizes.md,
}))

export const ModalContainer = styled.View(({ theme }) => ({
  flexDirection: 'column',
  backgroundColor: theme.colors.background0,
  padding: theme.sizes.sm,
  borderRadius: 10,
  alignItems: 'center',
  margin: theme.sizes.md,
  gap: theme.sizes.sm,
  minHeight: 300,
  maxHeight: '80%',
  width: '90%',
  alignSelf: 'center',
  justifyContent: 'flex-start',
}))

export const ModalHeader = styled.View(({ theme }) => ({
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
}))

export const PreviewButtonContainer = styled(View)(({ theme }) => ({
  paddingTop: theme.sizes.xs,
  paddingBottom: theme.sizes.xs,
}))

export const HeaderContainer = styled(View)(({ theme }) => ({
  flexDirection: 'row',
  justifyContent: 'flex-start',
  alignItems: 'center',
  padding: theme.sizes.xxs,
}))

export const TitleContainer = styled(View)(({ theme }) => ({
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  width: '85%',
}))

export const ButtonContainer = styled(View)(({ theme }) => ({
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: theme.sizes.xxs,
  width: '100%',
  paddingTop: theme.sizes.md,
}))

export const DatePickerWrapper = webStyled('div')`
  .datepicker-styled {
    width: 100%;
    padding: 14.472px;
    border: 1px solid #e8e8e8;
    border-radius: 8px;
    background-color: #f6f6f6;
    font-size: 15.66px;
    font-family: 'SourceSans3-Regular';
    color: #000;
    outline: none;
  }
  
  .datepicker-styled::placeholder {
    color: grey;
  }
`

// Botón deshabilitado (gris)
export const DisabledButton = styled(TouchableOpacity)`
  background-color: ${colors.grisMedio};
  padding-vertical: 14px;
  border-radius: 5px;
  align-items: center;
`

export const ButtonContent = styled(View)`
  flex-direction: row;
  align-items: center;
  gap: 8px;
`

export const DisabledButtonText = styled(BaseText)(({ theme }) => ({
  fontWeight: '500',
  fontSize: theme.fontSizes['cta_medium'].fontSize,
  color: colors.azulCorporativo,
  fontFamily: 'Inter-Bold',
  lineHeight: theme.fontSizes['cta_medium'].lineHeight,
  letterSpacing: theme.fontSizes['cta_medium'].letterSpacing,
}))

export const Container = styled(View)(({ theme }) => ({
  alignItems: 'center',
  padding: theme.sizes.md,
  gap: theme.sizes.sm,
  maxWidth: 800,
  width: '100%',
  alignSelf: 'center'
}))


export const BenefitsContainer = styled(View)(({ theme }) => ({
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'stretch',
  width: '92%',
  alignSelf: 'center',
  gap: theme.sizes.xxl,
  marginTop: theme.sizes.sm,
  marginBottom: theme.sizes.md,
}))

export const QRImage = styled(ResourceImage)(() => ({
  padding: 0,
  width: 220,
  height: 220,
}))

export const DatacContainer = styled(View)(({ theme }) => ({
  alignItems: 'center',
}))

export const ActiveContainer = styled.View<{
  active: boolean
}>(({ theme, active }) => ({
  width: '92%',
  alignSelf: 'center',
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.sizes.md,
  paddingVertical: 20,
  paddingHorizontal: 22,
  borderRadius: 18,
  borderWidth: 1,
  borderColor: active ? '#57a75f' : '#c30000',
  // Tinte suave del color de estado.
  backgroundColor: active ? '#eef7ef' : '#fbecec',
  // Sombra suave para dar profundidad.
  shadowColor: active ? '#57a75f' : '#c30000',
  shadowOffset: { width: 0, height: 4 },
  shadowOpacity: 0.12,
  shadowRadius: 12,
  elevation: 4,
  // Misma separación que tiene el botón exterior con las 3 tarjetas de arriba
  // (~56px): el exterior tiene marginBottom 6, así que 6 + 50 ≈ 56.
  marginTop: 50,
}))

// Disco con el icono de estado a la izquierda del cuadro.
export const ActiveIconBadge = styled.View<{
  active: boolean
}>(({ active }) => ({
  width: 48,
  height: 48,
  borderRadius: 24,
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: active ? '#dcefe0' : '#f6d6d6',
}))

// Columna de textos (titulo + subtitulo) a la derecha del icono.
export const ActiveTextColumn = styled.View(() => ({
  flex: 1,
  gap: 2,
}))

export const ActiveText = styled.Text<{ active: boolean, type: string }>(({ theme, active }) => ({
  color: active ? '#3f8a47' : '#a30000',
  textAlign: 'left',
  fontSize: 14,
  lineHeight: 20,
}))
export const ActiveTextBold = styled.Text<{ active: boolean, type: string }>(({ theme, active }) => ({
  fontSize: 20,
  fontWeight: "bold",
  color: active ? '#57a75f' : '#c30000',
  textAlign: 'left',
  lineHeight: 26,
}))

export const BenefitContainer = webStyled.div(({ theme }) => ({
  alignItems: 'center',
  maxWidth: 100,
  rowGap: 5,
  display: 'flex',
  flexDirection: 'column',
}))
